<!-- design-lint-disable form-uses-precognition (password reset request: a live check would tell a visitor which emails have accounts) -->
<script>
  import { useForm } from '@inertiajs/svelte'
  import FlashMessage from '../../components/flash_message.svelte'
  import LegacyCmsBanner from '../../components/legacy_cms_banner.svelte'
  import { Button } from '../../components/ui'

  let { email = '' } = $props()

  const form = useForm({
    admin_site_admin: { email: email || '' }
  })

  function submit(e) {
    e.preventDefault()
    $form.post('/forgot-password')
  }
</script>

<LegacyCmsBanner />
<div class="min-h-screen bg-base-200 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
  <FlashMessage />
  <div class="card bg-base-100 shadow-md p-8 w-full max-w-md space-y-8">
    <h2 class="text-lg font-bold text-center">Forgot your password?</h2>

    <form novalidate onsubmit={submit} class="space-y-4">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Email</legend>
        <input
          type="email"
          bind:value={$form.admin_site_admin.email}
          class="input w-full"
          class:input-error={$form.errors.email}
          placeholder="Enter your email"
          autocomplete="email"
        />
        {#if $form.errors.email}
          <div class="text-error text-sm mt-1">{$form.errors.email[0]}</div>
        {/if}
      </fieldset>

      <Button type="submit" variant="primary" block loading={$form.processing}>Send reset instructions</Button>
    </form>

    <div class="text-center text-sm">
      <a href="/sign-in" class="link link-primary">Back to sign in</a>
    </div>
  </div>
</div>
